import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * ValidateNextRecurrences
 *
 * @private
 */
export const validateNextRecurrences = createAsyncThunk<
  // Return type of the payload creator
  uui.domain.actions.rpc.order.ValidateNextRecurrencesResult['result'],
  // First argument to the payload creator
  uui.domain.actions.rpc.order.ValidateNextRecurrencesAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('rpc/order/validateNextRecurrences', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/order/validateNextRecurrences', {
      category: 'rpc',
      type: 'rpc/order/validateNextRecurrences',
      payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on validateNextRecurrences`,
      { tags: ['rpc', 'support'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `validateNextRecurrences call failed`,
      error,
    })
  }
})
